import { ActivityTable } from "../components/audit/ActivityTable";
import { Section } from "../components/Section";

export function AuditLog() {
  return (
    <>
      <Section.Title>Audit Logs</Section.Title>
      <ActivityTable />
    </>
  );
}
